import {LibraryContentTypeDTO, type ExploreLibraryItemDTO} from '@/ts/types/dto/recco/library.dto';
import {ReccoChallengeStateDTO} from '@/ts/types/dto/recco/challenge';

function progressOf(item: ExploreLibraryItemDTO): number {
  return item.challenge?.pctCompletionProgress ?? 0;
}

/** True when the user has started the item (an in-progress challenge). */
export function isStartedCatalogItem(item: ExploreLibraryItemDTO): boolean {
  return item.contentType === LibraryContentTypeDTO.Challenge
    && item.challenge?.challengeState === ReccoChallengeStateDTO.IN_PROGRESS;
}

/**
 * Catalog rail ordering (IPD-2943): started items first — highest progress first, i.e.
 * closest to finishing — while the remaining items keep the BE relevance order.
 * The enrollment date is not exposed on the preview DTOs, so progress is the tiebreaker.
 */
export function orderStartedFirst(items: ExploreLibraryItemDTO[]): ExploreLibraryItemDTO[] {
  const started = items.filter(isStartedCatalogItem).sort((a, b) => progressOf(b) - progressOf(a));
  const rest = items.filter((item) => !isStartedCatalogItem(item));
  return [...started, ...rest];
}
